import { csx, Flex, IconCaretRight } from '@vtex/admin-ui'
import type { HTMLAttributes } from 'react'
import React from 'react'

type ProductDetailsSectionItemProps = {
  title: string
} & HTMLAttributes<HTMLDivElement>

export const ProductDetailsSectionItem = ({
  onClick,
  title,
  ...props
}: ProductDetailsSectionItemProps) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      className={csx({
        cursor: 'pointer',
        borderTop: '$neutral',
        ':hover': {
          color: '$blue40',
        },
      })}
      onClick={onClick}
      {...props}
    >
      <p
        className={csx({
          text: '$title1',
          paddingY: '$space-6',
        })}
      >
        {title}
      </p>

      <IconCaretRight size="small" className={csx({ fontWeight: 600 })} />
    </Flex>
  )
}
